<script setup lang="ts">
defineOptions({
  name: 'BlankLayout'
})
</script>

<template>
  <v-app>
    <a href="#main-content" class="sr-only skip-link">Zum Inhalt springen</a>
    <main id="main-content">
      <NuxtPage />
    </main>
  </v-app>
</template>

<style scoped lang="scss">
.skip-link:focus {
  position: fixed;
  top: 1rem;
  left: 1rem;
  z-index: 9999;
  width: auto;
  height: auto;
  padding: 0.75rem 1.5rem;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
  background: #fff;
  color: rgba(var(--v-theme-primary), 1);
  font-weight: 600;
  text-decoration: none;
  border: 2px solid rgba(var(--v-theme-primary), 1);
}
</style>
